import icon1 from "./img/whatsappMarketing_icon.png";
import icon2 from "./img/wpAds_icon.png";
import icon3 from "./img/chatboat_Icon.png";
import icon4 from "./img/payment_icon.png";
import icon5 from "./img/form_icon.png";
import icon6 from "./img/webwiew_icon.png";
import icon7 from "./img/button_icon.png";
import icon8 from "./img/qr_icon1.png";

export const menuItems = [
  {
    title: 'About Us',
  },
  {
    title: "Products",
    menu: "products",
    content: [
      {
        title: "WhatsApp Marketing",
        description:
          "Reach and engage customers instantly via WhatsApp messages.",
        icon: (
          <img
            src='./menuIcons/products/marketing.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/whatsapp-marketing",
      },
      {
        title: "Click to WhatsApp Ads",
        description: "Start chats instantly from ads on WhatsApp.",
        icon: (
          <img
            src='./menuIcons/products/2.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/whatsapp-adds",
      },
      {
        title: "WhatsApp Chatbots",
        description: "Automate customer chats on WhatsApp 24/7.",
        icon: (
          <img
            src='./menuIcons/products/bot.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/whatsapp-chatboat",
      },
      {
        title: "WhatsApp Payments",
        description: "Send and receive payments directly on WhatsApp.",
        icon: (
          <img
            src='./menuIcons/products/smartphone.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/whatsapp-payment",
      },
      {
        title: "Whatsapp Forms",
        description: "Collect user data seamlessly through WhatsApp.",
        icon: (
          <img
            src='./menuIcons/products/form.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/whatsapp-form",
      },
      {
        title: "WhatsApp WebViews",
        description: "Display web content inside WhatsApp chats.",
        icon: (
          <img
            src='./menuIcons/products/globe.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/whatsapp-webview",
      },
      {
        title: "WhatsApp Button",
        description:
          "Easily connect with customers via a clickable WhatsApp button.",
        icon: (
          <img
            src='./menuIcons/products/whatsapp.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/whatsapp-button",
      },
      {
        title: "WhatsApp Link & QR",
        description:
          "IConnect instantly through a shareable link or scannable QR code.",
        icon: (
          <img
            src='./menuIcons/products/qr.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/whatsapp-link",
      },
    ],
  },
  {
    title: "Industries",
    menu: "industries",
    content: [
      {
        title: "Education & Edtech",
        description: "Engage students and simplify admissions.",
        icon: (
          <img
            src='./menuIcons/industries/edtech.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 0,
      },
      {
        title: "Healthcare",
        description:
          "Streamline patient communication and appointment management through WhatsApp.",
        //  A healthier way to connect.
        icon: (
          <img
            src='./menuIcons/industries/health.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 1,
      },
      {
        title: "Finance",
        description:
          "Automate reminders, payments and customer queries for seamless financial services.",
        icon: (
          <img
            src='./menuIcons/industries/finance.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 2,
      },
      {
        title: "E-commerce",
        description:
          "Enhance your customer experience with order tracking, notifications and support on WhatsApp.",
        icon: (
          <img
            src='./menuIcons/industries/ecomm.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 3,
      },
      {
        title: "Retail",
        description:
          "Boost sales by automating personalized offers and customer engagement via WhatsApp.",
        icon: (
          <img
            src='./menuIcons/industries/retail.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 4,
      },
      {
        title: "Travel & Tourism",
        description:
          "Simplify bookings, itineraries and real-time updates through WhatsApp for travelers.",
        icon: (
          <img
            src='./menuIcons/industries/travel.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 5,
      },
      {
        title: "Hospitality",
        description:
          "Offer a seamless guest experience with booking confirmations and customer support on WhatsApp.",
        icon: (
          <img
            src='./menuIcons/industries/hospitality.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 6,
      },

      {
        title: "Logistics",
        description:
          "Automate delivery notifications, order tracking and customer support for smooth logistics operations.",
        icon: (
          <img
            src='./menuIcons/industries/logistics.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 7,
      },
      {
        title: "Real Estate",
        description:
          "Engage leads, schedule site visits and share property details easily via WhatsApp.",
        icon: (
          <img
            src='./menuIcons/industries/house.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 8,
      },
      {
        title: "Insurance",
        description:
          "Assist customers with policy information, claims and renewals through WhatsApp.",
        icon: (
          <img
            src='./menuIcons/industries/insurance.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 9,
      },
      {
        title: "Media & Entertainment",
        description:
          "Promote events, manage tickets and engage audiences through WhatsApp.",
        icon: (
          <img
            src='./menuIcons/industries/media.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 10,
      },
      {
        title: "Government Services",
        description:
          "Enable citizens to access government services and updates conveniently on WhatsApp.",
        icon: (
          <img
            src='./menuIcons/industries/bank.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
        index: 11,
      },
    ],
  },

  {
    title: "Resources",
    menu: "resources",
    content: [
      {
        title: "Help Center",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
      {
        title: "Tutorials",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
      {
        title: "Template Library",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
      {
        title: "Blog",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
      {
        title: "Developer APIs ",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
      {
        title: "Case Studies",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
    ],
  },
  {
    title: "Integrations",
    menu: "integrations",
    content: [
      {
        title: "Help Center",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
      {
        title: "Tutorials",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
      {
        title: "Template Library",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
      {
        title: "Blog",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
      {
        title: "Developer APIs ",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
      {
        title: "Case Studies",
        icon: (
          <img
            src='./menuIcons/help.png'
            alt="WhatsApp Marketing Icon"
            style={{ width: 26, height: 26 }}
          />
        ),
        path: "/about",
      },
    ],
  },
  {
    title: 'Price',
  },
];

